import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as fromActions from './actions'
import { ICan } from 'app/models/can';
import * as fromBeverage from 'app/state/beverage/reducer';
import * as fromLoation from 'app/state/location/reducer';

// export interface BeverageState {
//   beverages: IBeverage[];
//   error: string;
// }

export interface State extends EntityState<ICan> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
  ean: string;
}

export function sortByName(a: ICan, b: ICan): number {
  return a.name.localeCompare(b.name);
}

export function selectId(a: ICan): string {
  return a.id ?? '';
}

export const adapter: EntityAdapter<ICan> = createEntityAdapter<ICan>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  error: '',
  ean: ''
});

export const stateName = 'can';

// Reducers
export const reducer = createReducer<State>(
  initialState,
  on(fromActions.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),
  on(fromActions.loadItemsSuccess, (state, { items }) => { return adapter.setAll(items, state); }),
  on(fromActions.deleteItemSuccess, (state, { id }) => { return adapter.removeOne(id, state); }),
  on(fromActions.loadItemsFailure, (state, action) => {
    return {
      ...state,
      entities: {},
      error: action.error
    };
  }),
  on(fromActions.setItem, (state, action) => Object.assign({ ...state, selectedId: action.id })),
  on(fromActions.setEan, (state, action) => Object.assign({ ...state, ean: action.ean })),



);


// get the selectors
const {
  selectAll,
  selectEntities: selectItemEntities,
  selectIds: selectItemIds,
  selectTotal
} = adapter.getSelectors();


// ***** SELECTORS *******
export const getSelectedId = (state: State) => state.selectedId;
export const getEan = (state: State) => state.ean;
export const getState = createFeatureSelector<State>(stateName);
export const selectIds = createSelector(getState, selectItemIds);
export const selectEntities = createSelector(getState, selectItemEntities);
export const selectAllItems = createSelector(getState, selectAll);
export const selectEan = createSelector(getState, getEan);
//export const getAllEntities = createSelector(getState, selectEntities);

export const getCount = createSelector(getState, selectTotal);
export const selectCurrentId = createSelector(getState, getSelectedId);
export const selectCurrentItem = createSelector(selectEntities, selectCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});
export const selectEntity = (id: string) => createSelector(selectEntities, entities => entities[id]);


export const selectAllItemsForBeverage = (beverageId: string) =>
  createSelector(selectAllItems, items => items.filter(i => i.beverageId === beverageId));

export const selectAllItemsForCurrentBeverage =
  createSelector(
    selectAllItems,
    fromBeverage.selectCurrentId,
    (items, beverageId) => {
      return items.filter(i => i.beverageId === beverageId);
    });


export const selectAllItemsFromCurrentLocation =
  createSelector(
    selectAllItems,
    fromLoation.selectCurrentId,
    (items, locationId) => {
      return items.filter(i => i.locationId === locationId) as ICan[];
    });
